import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardLayout from "../layout/index";
import { toast } from "react-toastify";
import { getHospitalDetails } from "../../utils/hospitalStorage";

function submitPaymentGatewayForm(html) {
  const container = document.createElement("div");
  container.innerHTML = html || "";
  const form = container.querySelector("form");
  if (form) {
    document.body.appendChild(form);
    form.submit();
    return true;
  }
  return false;
}

const STEP_LABELS = ["Choose Slot", "Patient & Symptoms", "Confirm Referral"];
const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
const SHORT_MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const DAYS = ["Su","Mo","Tu","We","Th","Fr","Sa"];
const COMMON_SYMPTOMS = [
  "Fever","Headache","Vomiting","Weakness","Chest Pain",
  "Breathlessness","Cough","Sweating","Weight Changes","Fatigue",
  "Nausea","Dizziness","Back Pain","Joint Pain","Stomach Pain",
];

function buildCalendar(year, month) {
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const prevDays = new Date(year, month, 0).getDate();
  const cells = [];
  for (let i = firstDay - 1; i >= 0; i--) cells.push({ day: prevDays - i, current: false });
  for (let i = 1; i <= daysInMonth; i++) cells.push({ day: i, current: true });
  while (cells.length < 42) cells.push({ day: cells.length - firstDay - daysInMonth + 2, current: false });
  return cells;
}

function getInitials(doc) {
  const f = (doc?.firstName || "?")[0] || "";
  const l = (doc?.lastName || "")[0] || "";
  return (f + l).toUpperCase() || "DR";
}

function getFullName(doc) {
  return [doc?.firstName, doc?.middleName, doc?.lastName].filter(Boolean).join(" ").trim() || "Doctor";
}

function to12Hour(timeStr) {
  if (!timeStr) return timeStr;
  const convert = (t) => {
    const [hStr, mStr] = t.trim().split(":");
    const h = parseInt(hStr, 10);
    const m = mStr || "00";
    const period = h >= 12 ? "PM" : "AM";
    const hour = h % 12 || 12;
    return `${hour}:${m} ${period}`;
  };
  const parts = timeStr.split("-");
  if (parts.length === 2) {
    const t1 = convert(parts[0]);
    const t2 = convert(parts[1]);
    const period = t2.slice(-2);
    const t1clean = t1.endsWith(period) ? t1.slice(0, -3) : t1;
    return `${t1clean} – ${t2}`;
  }
  return convert(timeStr);
}

export default function CurebayReferralBooking() {
  const navigate = useNavigate();
  const location = useLocation();
  const { patientcbcode, patient, referralDoctor } = location.state || {};
  console.log(patientcbcode ,patient, referralDoctor,"patientCode, patient, referralDoctor");
  

  const DOCTOR_API_URL = process.env.REACT_APP_NEW_DOCTOR_URL;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const [step, setStep] = useState(1);
  const [calYear, setCalYear] = useState(today.getFullYear());
  const [calMonth, setCalMonth] = useState(today.getMonth());
  const [selectedDate, setSelectedDate] = useState(new Date(today));
  const [slots, setSlots] = useState({ morning: [], afternoon: [], evening: [], morningMessage: null, afternoonMessage: null, eveningMessage: null });
  const [slotsLoading, setSlotsLoading] = useState(false);
  const [activeSession, setActiveSession] = useState("afternoon");
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [selectedSymptoms, setSelectedSymptoms] = useState([]);
  const [chiefComplaint, setChiefComplaint] = useState("");
  const [booking, setBooking] = useState(false);
  const [paying, setPaying] = useState(false);
  const [appointmentId, setAppointmentId] = useState(null);

  const formatDate = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  useEffect(() => {
    if (referralDoctor?.code) fetchSlots(selectedDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);

  const fetchSlots = async (date) => {
    setSlotsLoading(true);
    setSelectedSlot(null);
    try {
      const params = new URLSearchParams({
        doctorCode: referralDoctor.code,
        date: formatDate(date),
        consultationType: "V",
      });
      const res = await fetch(`${DOCTOR_API_URL}/slot/available?${params}`);
      const data = await res.json();

      const s = data?.slots || data;
      const toSlotArr = (arr) =>
        (Array.isArray(arr) ? arr : []).map((item) =>
          typeof item === "string" ? { slot: item, available: "Y" } : item
        );

      const morning = toSlotArr(s?.morning || s?.Morning);
      const afternoon = toSlotArr(s?.afternoon || s?.Afternoon);
      const evening = toSlotArr(s?.evening || s?.Evening);
      const availCount = (arr) => arr.filter((x) => x.available === "Y").length;

      setSlots({
        morning, afternoon, evening,
        morningMessage: s?.morningMessage || null,
        afternoonMessage: s?.afternoonMessage || null,
        eveningMessage: s?.eveningMessage || null,
      });

      if (availCount(afternoon) > 0) setActiveSession("afternoon");
      else if (availCount(morning) > 0) setActiveSession("morning");
      else setActiveSession("evening");
    } catch {
      toast.error("Failed to load available slots");
      setSlots({ morning: [], afternoon: [], evening: [], morningMessage: null, afternoonMessage: null, eveningMessage: null });
    } finally {
      setSlotsLoading(false);
    }
  };

  const cells = buildCalendar(calYear, calMonth);

  const handleDateClick = (cell) => {
    if (!cell.current) return;
    const d = new Date(calYear, calMonth, cell.day);
    d.setHours(0, 0, 0, 0);
    if (d < today) return;
    setSelectedDate(d);
  };

  const prevMonth = () => {
    if (calMonth === 0) { setCalYear((y) => y - 1); setCalMonth(11); }
    else setCalMonth((m) => m - 1);
  };
  const nextMonth = () => {
    if (calMonth === 11) { setCalYear((y) => y + 1); setCalMonth(0); }
    else setCalMonth((m) => m + 1);
  };

  const isPastMonth =
    calYear < today.getFullYear() ||
    (calYear === today.getFullYear() && calMonth <= today.getMonth());

  const toggleSymptom = (s) =>
    setSelectedSymptoms((prev) =>
      prev.includes(s) ? prev.filter((x) => x !== s) : [...prev, s]
    );

  const handleConfirm = async () => {
    setBooking(true);
    try {
      const hospitalDetails = getHospitalDetails();
      const hospitalId = localStorage.getItem("hospitalid") || hospitalDetails?.hospitalId || "";
      const locationId = hospitalDetails?.locationId || hospitalDetails?.locationCode || "";

      const [fromTime, toTime] = selectedSlot ? selectedSlot.split("-") : ["", ""];
      const dateStr = formatDate(selectedDate);
      const whenAppointment = `${dateStr}T${(fromTime || "").trim()}:00`;

      const consultationsReason = selectedSymptoms.length > 0
        ? selectedSymptoms.join(",")
        : chiefComplaint || "";

      const payload = {
        patientId: patientcbcode,
        userId: referralDoctor?.code || "",
        hospitalId,
        locationId,
        cancelledReason: null,
        cheBranchId: null,
        cheCenterId: null,
        consultationsReason,
        consultationsType: "V",
        corporate: "NO",
        enquiryId: null,
        fromTime: (fromTime || "").trim(),
        isFollowUp: "N",
        medicineOrderId: null,
        refAppointmentId: null,
        remarks: chiefComplaint || null,
        sourceChannel: "SC",
        toTime: (toTime || "").trim(),
        voucherCode: null,
        voucherTransId: null,
        whenAppointment,
      };

      const token = localStorage.getItem("auth_token");
      const res = await fetch(`${DOCTOR_API_URL}/appointments/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setAppointmentId(data?.id || data?.appointmentId || data?.data?.id || null);
      handleSaveAppointment(data);
      setStep(3);
    } catch {
      toast.error("Failed to confirm referral");
    } finally {
     
    }
  };


  const handleSaveAppointment = async (data) => {
    const API_URL = process.env.REACT_APP_API_URL;
  
    try {
      
        const clinicId = localStorage.getItem("clinicId");
        const userId = localStorage.getItem("userId");
      const payload = {
        clinicId: clinicId,
        patientName: patient?.firstName + " " + patient?.lastName,
        orderPlacedTo: "SMART_CLINIC",
        patientMobileNo: patient?.mobileNumber,
        appointmentId: "",
        patientId: patient?.patientId,
        address: "",
        patientAge: patient?.age,
        // ambulaceRequestReason: "",
        // ambulanceEnquiryList: [],
        appoimentDetails: [],
        amount: data?.totalAmount,
        discountedAmount: 0,
        createdDate:new Date(),
        createdby:userId,
        modifiedDate:new Date(),
        modifiedBy:userId,
        curebayAppointmentId:data?.id,
        // ServiceType:"CONSULTATION",
        
    }

      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      const response = await fetch(`${API_URL}orders/save`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
        body: JSON.stringify(payload),
      });
      
      console.log("Response status:", response.status);

      const result = await response.json();
      console.log(result, "result");
    } catch {
     
    } finally {
      setBooking(false);
    }
  };

  const handlePayNow = async () => {
    if (!appointmentId) {
      toast.error("Appointment ID missing. Please confirm the booking again.");
      return;
    }

    setPaying(true);
    try {
      const hospitalDetails = getHospitalDetails();
      const hospitalId =
        localStorage.getItem("hospitalid") || hospitalDetails?.hospitalId || "";
      const payload = {
        appointmentId,
        payMode: "Digital Payment",
        partnerFee: "0.00",
        createdBy: hospitalId,
        modifiedBy: hospitalId,
        cheBranchName: "Bhubaneswar",
        cheCenterName: "Central eClinic - Bhubaneswar",
        paymentLinkForPatient: "Y",
        sourceChannel: "SC",
      };

      const token = localStorage.getItem("auth_token");
      const res = await fetch(`${DOCTOR_API_URL}/billing-temp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(payload),
      });

      const raw = await res.text();
      console.log("[PAY] HTTP status:", res.status);
      console.log("[PAY] Raw response (first 2000 chars):", raw.slice(0, 2000));

      let result;
      try {
        result = JSON.parse(raw);
        console.log("[PAY] Parsed JSON result:", result);
      } catch {
        result = null;
        console.log("[PAY] Response is not JSON — treating as raw HTML");
      }

      if (result?.data || res.status === 200 || result?.success) {
        let paymentHtml = raw;
        if (result?.paymentInitiationResponse?.data) {
          paymentHtml = result.paymentInitiationResponse.data;
          console.log("[PAY] Using paymentInitiationResponse.data as HTML");
        } else if (result?.data) {
          paymentHtml = result.data;
          console.log("[PAY] Using result.data as HTML");
        } else {
          console.log("[PAY] Using raw response as HTML");
        }

        console.log("[PAY] Payment HTML to submit (first 2000 chars):", paymentHtml.slice(0, 2000));

        // Parse and log all form fields (especially return/callback URLs)
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = paymentHtml;
        const form = tempDiv.querySelector("form");
        if (form) {
          console.log("[PAY] Form action (gateway URL):", form.action);
          console.log("[PAY] Form method:", form.method);
          const fields = {};
          form.querySelectorAll("input").forEach((inp) => {
            fields[inp.name] = inp.value;
          });
          console.log("[PAY] All form hidden fields:", fields);
        } else {
          console.warn("[PAY] No <form> found in payment HTML!");
        }

        // Save appointment details so the payment success page can display them
        localStorage.setItem(
          "appointmentDetails",
          JSON.stringify({
            doctorName: getFullName(referralDoctor),
            doctorPhoto: referralDoctor?.photo || "",
            specialization: referralDoctor?.speciality || "",
            patientName: [patient?.firstName, patient?.middleName, patient?.lastName].filter(Boolean).join(" ").trim(),
            appointmentNo: String(appointmentId || ""),
            appointmentDate: formatDate(selectedDate),
            appointmentTime: selectedSlot?.slot || selectedSlot || "",
          })
        );

        if (!submitPaymentGatewayForm(paymentHtml)) {
          toast.error("Failed to initiate payment: invalid payment form.");
        }
      } else {
        console.error("[PAY] Payment initiation failed. result:", result);
        toast.error("Failed to initiate payment.");
      }
    } catch (error) {
      console.error("[PAY] Payment API Error:", error);
      toast.error("Failed to initiate payment");
    } finally {
      setPaying(false);
    }
  };

  const doctorName = getFullName(referralDoctor || {});
  const initials = getInitials(referralDoctor || {});
  const patientName = patient
    ? `${patient.firstName || ""} ${patient.lastName || ""}`.trim()
    : patientcbcode || "—";
  const fee =
    referralDoctor?.effectiveConsultationFee != null
      ? `₹${referralDoctor.effectiveConsultationFee}`
      : referralDoctor?.videoConsFee != null  
      ? `₹${referralDoctor.videoConsFee}`
      : "—";

  const btnPrimary =
    "flex items-center gap-1.5 text-white text-sm font-bold px-5 py-2.5 rounded-lg hover:opacity-90 active:scale-[0.98] shadow-sm bg-gradient-to-r from-[#004276] to-[#2E7D5E]";

  // ─── Stepper ───
  const Stepper = () => (
    <div className="flex items-center justify-center mb-5 max-w-xl mx-auto">
      {STEP_LABELS.map((label, i) => {
        const num = i + 1;
        const isDone = step > num;
        const isActive = step === num;
        return (
          <React.Fragment key={label}>
            <div className="flex flex-col items-center gap-1">
              <div className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 transition-all ${
                isDone ? "bg-[#2E7D5E] text-white"
                : isActive ? "bg-[#2E7D5E] text-white ring-2 ring-[#2E7D5E]/25"
                : "bg-gray-100 text-gray-400 border border-gray-200"
              }`}>
                {isDone ? (
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
                    <path d="M20 6L9 17l-5-5" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                ) : num}
              </div>
              <span className={`text-xs font-semibold whitespace-nowrap ${
                isActive ? "text-[#2E7D5E]" : isDone ? "text-[#2E7D5E]" : "text-gray-400"
              }`}>{label}</span>
            </div>
            {i < STEP_LABELS.length - 1 && (
              <div className={`h-px w-10 sm:w-14 mx-2 mb-4 ${step > num ? "bg-[#2E7D5E]" : "bg-gray-200"}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );

  // ─── Doctor sidebar card (steps 2 & 3) ───
  const DoctorMiniCard = () => (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <div className="h-1 bg-gradient-to-r from-[#004276] to-[#2E7D5E]" />
      <div className="p-3.5">
        <div className="flex items-center gap-2.5 mb-2.5">
          <div className="w-10 h-10 rounded-full bg-[#2E7D5E] flex items-center justify-center text-white font-bold text-sm flex-shrink-0">{initials}</div>
          <div className="min-w-0">
            <p className="font-bold text-gray-900 text-sm leading-tight truncate">Dr. {doctorName}</p>
            {referralDoctor?.qualification && <p className="text-xs text-gray-400 mt-0.5 truncate">{referralDoctor.qualification}</p>}
            {referralDoctor?.speciality && <p className="text-xs font-semibold text-[#2E7D5E] mt-0.5">{referralDoctor.speciality.split(",")[0]}</p>}
          </div>
        </div>
        <div className="flex items-center justify-between pt-2 border-t border-gray-100">
          <span className="text-xs text-gray-400">{referralDoctor?.yearsOfExperience ? `${referralDoctor.yearsOfExperience} yrs exp` : ""}</span>
          <span className="text-base font-bold text-[#004276]">{fee}</span>
        </div>
      </div>
      {selectedSlot && (
        <div className="mx-3 mb-3 bg-[#E8F5F0] rounded-lg px-2.5 py-2 border border-[#C8E6C9]">
          <p className="text-xs text-gray-400 font-bold uppercase tracking-wide mb-0.5">Scheduled</p>
          <p className="text-sm font-bold text-[#004276]">{SHORT_MONTHS[selectedDate.getMonth()]} {selectedDate.getDate()}, {selectedDate.getFullYear()}</p>
          <p className="text-xs text-[#2E7D5E] font-semibold mt-0.5">{to12Hour(selectedSlot)}</p>
        </div>
      )}
    </div>
  );

  return (
    <DashboardLayout>
      <div className="min-h-screen bg-gray-50 md:pt-6 md:px-6 px-4 pt-4 pb-10">

        {/* Header */}
        <div className="mb-5">
          <div className="flex items-center gap-2.5">
            
            <div className="w-7 h-7 rounded-full bg-[#2E7D5E] flex items-center justify-center flex-shrink-0">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="4" width="18" height="16" rx="2" stroke="white" strokeWidth="1.8"/>
                <path d="M8 2v4M16 2v4M3 10h18" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
              </svg>
            </div>
            <h1 className="text-base font-bold text-gray-900">Book Referral Appointment</h1>
          </div>
          {patient && (
            <div className="inline-flex items-center gap-2 mt-2 px-3 py-1.5 rounded-full"
              style={{ background: "linear-gradient(90deg, #e8f0fb 0%, #e6f7f0 100%)", border: "1px solid #c5dcf5" }}>
              <div className="w-6 h-6 rounded-full flex items-center justify-center text-white text-[11px] font-bold flex-shrink-0"
                style={{ background: "linear-gradient(135deg, #004172, #2E7D5E)" }}>
                {(patient.firstName || "P")[0].toUpperCase()}
              </div>
              <span className="text-sm font-bold text-[#004172]">
                {[patient.firstName, patient.middleName, patient.lastName].filter(Boolean).join(" ") || "Patient"}
              </span>
              {(patient.mobile || patient.mobileNumber || patient.phoneNumber || patient.phone) && (
                <>
                  <span className="w-1 h-1 rounded-full bg-[#004172]/30" />
                  <span className="text-xs font-semibold text-[#2E7D5E]">
                    {patient.mobile || patient.mobileNumber || patient.phoneNumber || patient.phone}
                  </span>
                </>
              )}
            </div>
          )}
        </div>

        <Stepper />

        {/* ══════════ STEP 1 ══════════ */}
        {step === 1 && (
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">

            {/* Doctor strip */}
            <div className="px-4 py-3 flex items-center gap-3 border-b border-gray-100 bg-gradient-to-r from-[#EAF4F0] to-[#E8F5F0]">
              <div className="w-10 h-10 rounded-full bg-[#2E7D5E] flex items-center justify-center text-white font-bold text-sm flex-shrink-0">{initials}</div>
              <div className="flex-1 min-w-0">
                <p className="font-bold text-gray-900 text-sm">Dr. {doctorName}</p>
                <p className="text-xs text-gray-500 truncate">{referralDoctor?.speciality}</p>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-xs text-gray-400 uppercase tracking-wide font-semibold">Consultation Fee</p>
                <p className="text-base font-bold text-[#004276]">{fee}</p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row">

              {/* Calendar */}
              <div className="md:w-[300px] flex-shrink-0 p-4 border-r border-gray-100">
                <div className="flex items-center justify-between mb-3">
                  <button onClick={prevMonth} disabled={isPastMonth}
                    className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-gray-100 disabled:opacity-30 transition-colors">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="#374151" strokeWidth="2" strokeLinecap="round"/></svg>
                  </button>
                  <span className="text-sm font-bold text-gray-800">{MONTHS[calMonth]} {calYear}</span>
                  <button onClick={nextMonth}
                    className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="#374151" strokeWidth="2" strokeLinecap="round"/></svg>
                  </button>
                </div>

                <div className="grid grid-cols-7 mb-1.5">
                  {DAYS.map((d) => <div key={d} className="text-center text-xs font-bold text-gray-400 py-0.5">{d}</div>)}
                </div>
                <div className="grid grid-cols-7 gap-y-1">
                  {cells.map((cell, i) => {
                    const cellDate = new Date(calYear, calMonth, cell.day);
                    cellDate.setHours(0, 0, 0, 0);
                    const isPast = cell.current && cellDate < today;
                    const isSelected = cell.current && cellDate.toDateString() === selectedDate.toDateString();
                    const isToday = cell.current && cellDate.toDateString() === today.toDateString();
                    return (
                      <button key={i} onClick={() => handleDateClick(cell)} disabled={!cell.current || isPast}
                        className={[
                          "w-8 h-8 mx-auto rounded-full text-xs flex items-center justify-center transition-all font-medium",
                          !cell.current ? "text-gray-200 cursor-default" : "",
                          cell.current && isPast ? "text-gray-300 cursor-not-allowed" : "",
                          cell.current && !isPast && !isSelected ? "text-gray-700 hover:bg-[#E8F5F0] hover:text-[#2E7D5E]" : "",
                          isSelected ? "bg-[#2E7D5E] text-white font-bold shadow-sm" : "",
                          isToday && !isSelected ? "ring-1.5 ring-[#2E7D5E] text-[#2E7D5E] font-bold" : "",
                        ].join(" ")}>
                        {cell.day}
                      </button>
                    );
                  })}
                </div>

                <div className="mt-3 flex items-center gap-2 bg-[#E8F5F0] border border-[#C8E6C9] rounded-lg px-2.5 py-2">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="4" width="18" height="16" rx="2" stroke="#2E7D5E" strokeWidth="2"/>
                    <path d="M8 2v4M16 2v4M3 10h18" stroke="#2E7D5E" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                  <span className="text-sm font-semibold text-[#2E7D5E]">
                    {selectedDate.toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short", year: "numeric" })}
                  </span>
                </div>
              </div>

              {/* Slots */}
              <div className="flex-1 p-4">
                <p className="text-sm font-bold text-gray-600 uppercase tracking-wide mb-3">Available Slots</p>

                {slotsLoading ? (
                  <div className="flex flex-col items-center justify-center h-40 gap-2">
                    <div className="w-7 h-7 rounded-full border-2 border-[#2E7D5E] border-t-transparent animate-spin" />
                    <p className="text-xs text-gray-400">Checking availability...</p>
                  </div>
                ) : (
                  <div className="flex flex-col gap-4">
                    {/* Session tabs */}
                    <div className="flex gap-1.5">
                      {[
                        { key: "morning", label: "Morning", activeBg: "#E8F5F0", activeBorder: "#2E7D5E", activeText: "#1B5E40", icon: (c) => (
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="4" stroke={c} strokeWidth="2"/>
                            <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" stroke={c} strokeWidth="2" strokeLinecap="round"/>
                          </svg>
                        )},
                        { key: "afternoon", label: "Afternoon", activeBg: "#FFF7ED", activeBorder: "#F59E0B", activeText: "#92400E", icon: (c) => (
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="5" stroke={c} strokeWidth="2"/>
                            <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41" stroke={c} strokeWidth="2" strokeLinecap="round"/>
                          </svg>
                        )},
                        { key: "evening", label: "Evening", activeBg: "#EDE9FE", activeBorder: "#7C3AED", activeText: "#4C1D95", icon: (c) => (
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                            <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        )},
                      ].map(({ key, label, activeBg, activeBorder, activeText, icon }) => {
                        const avail = slots[key].filter((x) => x.available === "Y").length;
                        const isActive = activeSession === key;
                        const iconColor = isActive ? activeText : "#9CA3AF";
                        return (
                          <button key={key} onClick={() => setActiveSession(key)}
                            style={isActive ? { backgroundColor: activeBg, borderColor: activeBorder, color: activeText } : {}}
                            className={`flex-1 flex items-center justify-center gap-1.5 py-2 rounded-lg text-sm font-semibold border transition-all ${
                              isActive ? "shadow-sm border" : "bg-white border-gray-200 text-gray-500 hover:border-[#2E7D5E]/40"
                            }`}>
                            {icon(iconColor)}
                            <span>{label}</span>
                            <span className="text-xs font-bold px-1.5 py-0.5 rounded-full"
                              style={isActive
                                ? {
                                    backgroundColor: activeText === "#ffffff" ? "rgba(255,255,255,0.25)" : "rgba(0,0,0,0.12)",
                                    color: activeText,
                                  }
                                : { backgroundColor: avail > 0 ? "#dcfce7" : "#f3f4f6", color: avail > 0 ? "#166534" : "#9ca3af" }
                              }>
                              {avail}
                            </span>
                          </button>
                        );
                      })}
                    </div>

                    {/* Slot grid */}
                    {slots[activeSession].length === 0 ? (
                      <div className="flex flex-col items-center justify-center py-10 gap-2">
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="12" r="9" stroke="#d1d5db" strokeWidth="1.5"/>
                          <path d="M12 7v5l3 3" stroke="#d1d5db" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                        <p className="text-sm text-gray-400 font-medium">No slots for this session</p>
                        {slots[`${activeSession}Message`] && (
                          <p className="text-xs text-amber-500">{slots[`${activeSession}Message`]}</p>
                        )}
                      </div>
                    ) : (
                      <div>
                        {slots[`${activeSession}Message`] && (
                          <p className="text-xs text-amber-500 font-medium mb-3">{slots[`${activeSession}Message`]}</p>
                        )}
                        <div className="flex flex-wrap gap-2">
                          {slots[activeSession].map((slotObj, i) => {
                            const isAvail = slotObj.available === "Y";
                            const isSel = selectedSlot === slotObj.slot;
                            return (
                              <button key={i}
                                onClick={() => isAvail && setSelectedSlot(slotObj.slot)}
                                disabled={!isAvail}
                                className={`px-3 py-2 rounded-lg text-sm font-semibold border transition-all ${
                                  !isAvail
                                    ? "bg-gray-50 text-gray-300 border-gray-100 cursor-not-allowed"
                                    : isSel
                                    ? "bg-[#2E7D5E] text-white border-[#2E7D5E] shadow-sm"
                                    : "bg-white text-gray-600 border-gray-200 hover:border-[#2E7D5E] hover:text-[#2E7D5E] hover:bg-[#E8F5F0]"
                                }`}>
                                {isAvail ? to12Hour(slotObj.slot) : <span className="line-through">{to12Hour(slotObj.slot)}</span>}
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* Footer */}
            <div className="px-4 py-3 border-t border-gray-100 bg-gray-50/80 flex items-center justify-between gap-3">
              <div>
                {selectedSlot ? (
                  <div className="flex items-center gap-1.5">
                    
                    <p className="text-sm text-gray-600">
                      <span className="font-bold text-[#004276]">{to12Hour(selectedSlot)}</span>
                      {" · "}
                      <span className="font-semibold text-gray-700">
                        {selectedDate.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
                      </span>
                    </p>
                  </div>
                ) : (
                  <p className="text-sm text-gray-400">No slot selected yet</p>
                )}
              </div>
              <button
                onClick={() => { if (!selectedSlot) { toast.warning("Please select a time slot"); return; } setStep(2); }}
                className={btnPrimary}>
                Continue
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12h14M13 6l6 6-6 6" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        )}

        {/* ══════════ STEP 2 ══════════ */}
        {step === 2 && (
          <div className="flex flex-col md:flex-row gap-4 items-start">
            <div className="md:w-52 flex-shrink-0"><DoctorMiniCard /></div>

            <div className="flex-1 space-y-3">
              {/* Patient */}
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4">
                <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">Referred Patient</p>
                <div className="flex items-center gap-2.5 p-3 bg-[#EAF4F0] border border-[#004276]/15 rounded-lg">
                  <div className="w-9 h-9 rounded-full bg-[#2E7D5E] flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
                    {(patient?.firstName || "P")[0]?.toUpperCase()}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-bold text-gray-900 text-sm">{patientName}</p>
                    {(patient?.mobileNumber || patientcbcode) && (
                      <p className="text-xs text-gray-500 mt-0.5">{patient?.mobileNumber || patientcbcode}</p>
                    )}
                  </div>
                  <div className="w-6 h-6 rounded-full bg-[#2E7D5E] flex items-center justify-center flex-shrink-0">
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                      <path d="M20 6L9 17l-5-5" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>

              {/* Symptoms */}
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4">
                <p className="text-sm font-bold text-gray-900 mb-0.5">What is bothering the patient?</p>
                <p className="text-sm text-gray-400 mb-3">Select one or more symptoms</p>
                <div className="flex flex-wrap gap-1.5">
                  {COMMON_SYMPTOMS.map((s) => {
                    const sel = selectedSymptoms.includes(s);
                    return (
                      <button key={s} onClick={() => toggleSymptom(s)}
                        className={`text-sm px-3 py-1.5 rounded-full border-2 font-medium transition-all ${
                          sel ? "bg-[#2E7D5E] text-white border-[#2E7D5E]"
                          : "bg-white text-gray-600 border-gray-200 hover:border-[#2E7D5E] hover:text-[#2E7D5E]"
                        }`}>
                        {sel && <span className="mr-0.5">&#10003;</span>}{s}
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* Chief complaint */}
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4">
                <p className="text-sm font-bold text-gray-900 mb-0.5">Chief Complaint</p>
                <p className="text-sm text-gray-400 mb-2">Describe the patient's problem in detail</p>
                <textarea
                  value={chiefComplaint}
                  onChange={(e) => setChiefComplaint(e.target.value)}
                  placeholder="e.g. Patient has been experiencing persistent chest pain for the last 3 days..."
                  rows={3}
                  className="w-full border-2 border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-700 placeholder:text-gray-400 outline-none focus:border-[#004276] resize-none transition-colors"
                />
              </div>

              <div className="flex justify-between pt-1">
                <button onClick={() => setStep(1)} className="text-sm font-semibold text-gray-500 hover:text-gray-700 border-2 border-gray-200 bg-white px-5 py-2 rounded-lg transition-colors">
                  &#8592; Back
                </button>
                <button onClick={handleConfirm} disabled={booking} className={`${btnPrimary} disabled:opacity-60`}>
                  {booking ? (
                    <><div className="w-3.5 h-3.5 rounded-full border-2 border-white border-t-transparent animate-spin" /> Confirming...</>
                  ) : (
                    <>Review &amp; Confirm
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
                        <path d="M5 12h14M13 6l6 6-6 6" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ══════════ STEP 3 ══════════ */}
        {step === 3 && (
          <div className="flex flex-col md:flex-row gap-4 items-start">
            <div className="md:w-52 flex-shrink-0"><DoctorMiniCard /></div>

            <div className="flex-1 space-y-3">
              {/* Summary */}
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                <div className="px-4 py-3 border-b border-gray-100 bg-gradient-to-r from-[#EAF4F0] to-[#E8F5F0]">
                  <p className="text-sm font-bold text-gray-900">Appointment Summary</p>
                  <p className="text-sm text-gray-400 mt-0.5">Please review before confirming</p>
                </div>
                <div className="p-4 grid grid-cols-2 gap-4">
                  {[
                    {
                      icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><rect x="3" y="4" width="18" height="16" rx="2" stroke="#004276" strokeWidth="2"/><path d="M8 2v4M16 2v4M3 10h18" stroke="#004276" strokeWidth="2" strokeLinecap="round"/></svg>,
                      label: "Date", value: selectedDate.toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "long", year: "numeric" }),
                    },
                    {
                      icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="#004276" strokeWidth="2"/><path d="M12 7v5l3 3" stroke="#004276" strokeWidth="2" strokeLinecap="round"/></svg>,
                      label: "Time", value: to12Hour(selectedSlot),
                    },
                    {
                      icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><rect x="2" y="6" width="14" height="12" rx="2" stroke="#004276" strokeWidth="2"/><path d="M16 10.5l5.5-3v9l-5.5-3v-3z" stroke="#004276" strokeWidth="2" strokeLinejoin="round"/></svg>,
                      label: "Type", value: "Video Consultation",
                    },
                    {
                      icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="8" r="3.5" stroke="#004276" strokeWidth="2"/><path d="M5 20c0-3.5 3.1-6 7-6s7 2.5 7 6" stroke="#004276" strokeWidth="2" strokeLinecap="round"/></svg>,
                      label: "Patient", value: patientName,
                    },
                  ].map(({ icon, label, value }) => (
                    <div key={label} className="flex items-start gap-2">
                      <div className="w-7 h-7 rounded-lg bg-[#EAF4F0] flex items-center justify-center flex-shrink-0 mt-0.5">{icon}</div>
                      <div>
                        <p className="text-xs text-gray-400 font-bold uppercase tracking-wide">{label}</p>
                        <p className="text-sm font-semibold text-gray-800 mt-0.5 leading-snug">{value}</p>
                      </div>
                    </div>
                  ))}

                  {selectedSymptoms.length > 0 && (
                    <div className="col-span-2 flex items-start gap-2">
                      <div className="w-7 h-7 rounded-lg bg-[#EAF4F0] flex items-center justify-center flex-shrink-0 mt-0.5">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M9 12l2 2 4-4" stroke="#004276" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><circle cx="12" cy="12" r="9" stroke="#004276" strokeWidth="2"/></svg>
                      </div>
                      <div>
                        <p className="text-xs text-gray-400 font-bold uppercase tracking-wide mb-1.5">Symptoms</p>
                        <div className="flex flex-wrap gap-1">
                          {selectedSymptoms.map((s) => (
                            <span key={s} className="text-xs bg-[#E8F5F0] text-[#2E7D5E] font-semibold px-2 py-0.5 rounded-full border border-[#C8E6C9]">{s}</span>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}

                  {chiefComplaint && (
                    <div className="col-span-2 flex items-start gap-2">
                      <div className="w-7 h-7 rounded-lg bg-[#EAF4F0] flex items-center justify-center flex-shrink-0 mt-0.5">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#004276" strokeWidth="2"/><polyline points="14 2 14 8 20 8" stroke="#004276" strokeWidth="2"/><line x1="8" y1="13" x2="16" y2="13" stroke="#004276" strokeWidth="2" strokeLinecap="round"/><line x1="8" y1="17" x2="12" y2="17" stroke="#004276" strokeWidth="2" strokeLinecap="round"/></svg>
                      </div>
                      <div>
                        <p className="text-xs text-gray-400 font-bold uppercase tracking-wide">Chief Complaint</p>
                        <p className="text-sm text-gray-700 mt-0.5 leading-relaxed">{chiefComplaint}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Fee */}
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4">
                <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">Fee Breakdown</p>
                <div className="flex justify-between items-center py-2 border-b border-dashed border-gray-200">
                  <span className="text-sm text-gray-500">Video consultation fee</span>
                  <span className="text-sm font-semibold text-gray-700">{fee}</span>
                </div>
                <div className="flex justify-between items-center pt-2">
                  <span className="text-sm font-bold text-gray-800">Total Amount</span>
                  <span className="text-base font-bold text-[#004276]">{fee}</span>
                </div>
              </div>

              <div className="flex justify-between pt-1">
                <button onClick={() => setStep(2)} className="text-sm font-semibold text-gray-500 hover:text-gray-700 border-2 border-gray-200 bg-white px-5 py-2 rounded-lg transition-colors">
                  &#8592; Back
                </button>
                <button onClick={handlePayNow} disabled={paying}
                  className={`${btnPrimary} px-6 disabled:opacity-60`}>
                  {paying ? (
                    <><div className="w-3.5 h-3.5 rounded-full border-2 border-white border-t-transparent animate-spin" /> Processing...</>
                  ) : (
                    <><svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>Pay Now</>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
